import React, { Fragment } from 'react';
import { motion } from 'framer-motion';
import { SunIcon, ZapIcon, BatteryChargingIcon, ActivityIcon, ArrowRightIcon, ArrowDownIcon } from 'lucide-react';
export function WhatIsSection() {
  const steps = [{
    icon: SunIcon,
    title: 'Light Energy',
    desc: 'Targeted laser light penetrates deep into the tissue without damaging the skin.'
  }, {
    icon: ZapIcon,
    title: 'Cellular Absorption',
    desc: 'Light energy is absorbed by chromophores within the cells, specifically targeting the mitochondria.'
  }, {
    icon: BatteryChargingIcon,
    title: 'ATP Production',
    desc: 'Cytochrome c oxidase is stimulated, supporting the production of ATP (cellular energy).'
  }, {
    icon: ActivityIcon,
    title: 'Recovery Response',
    desc: 'Increased cellular energy supports tissue repair, circulation, and reduced inflammation.'
  }];
  return <section className="py-20 md:py-28 bg-brand-gray-light" data-id="element-290">
      <div className="container mx-auto px-4 max-w-6xl" data-id="element-291">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center max-w-3xl mx-auto mb-16" data-id="element-292">
          <h2 className="text-3xl md:text-5xl font-bold text-brand-navy mb-6" data-id="element-293">
            What Is Aspen Laser Therapy?
          </h2>
          <div className="space-y-4 text-lg text-gray-600 leading-relaxed text-left md:text-center" data-id="element-294">
            <p data-id="element-295">
              Class IV laser therapy, also known as High Intensity Laser Therapy
              (HILT), utilizes specific wavelengths of light to interact with
              tissue. This process, known as <strong data-id="element-296">photobiomodulation</strong>
              , works at the cellular level to support the body's natural
              healing processes.
            </p>
            <p data-id="element-297">
              When the laser light is applied, the energy is absorbed by
              chromophores in your cells, especially in the mitochondria. This
              interaction helps stimulate cytochrome c oxidase, an enzyme that
              plays a crucial role in the production of ATP (adenosine
              triphosphate) — the primary energy source for your cells.
            </p>
            <p data-id="element-298">
              For patients, this complex science translates into simple,
              powerful benefits: more cellular energy, robust support for tissue
              repair, improved local circulation, reduced inflammation, and a
              faster path to recovery.
            </p>
          </div>
        </motion.div>

        <div className="relative" data-id="element-299">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4 md:gap-2" data-id="element-300">
            {steps.map((step, index) => <Fragment key={index} data-id="element-301">
                <motion.div initial={{
              opacity: 0,
              y: 20
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.5,
              delay: index * 0.15
            }} className="bg-white p-6 rounded-xl shadow-sm border border-gray-100 flex-1 w-full md:w-auto text-center relative z-10" data-id="element-302">
                  <div className="w-16 h-16 mx-auto bg-brand-teal/10 rounded-full flex items-center justify-center mb-4 text-brand-teal" data-id="element-303">
                    <step.icon className="w-8 h-8" data-id="element-304" />
                  </div>
                  <h3 className="text-xl font-bold text-brand-navy mb-2" data-id="element-305">
                    {step.title}
                  </h3>
                  <p className="text-gray-600 text-sm leading-relaxed" data-id="element-306">
                    {step.desc}
                  </p>
                </motion.div>

                {index < steps.length - 1 && <motion.div initial={{
              opacity: 0
            }} whileInView={{
              opacity: 1
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.3,
              delay: index * 0.15 + 0.1
            }} className="text-brand-teal/30 hidden md:block" data-id="element-307">
                    <ArrowRightIcon className="w-8 h-8" data-id="element-308" />
                  </motion.div>}

                {index < steps.length - 1 && <motion.div initial={{
              opacity: 0
            }} whileInView={{
              opacity: 1
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.3,
              delay: index * 0.15 + 0.1
            }} className="text-brand-teal/30 block md:hidden py-2" data-id="element-309">
                    <ArrowDownIcon className="w-6 h-6" data-id="element-310" />
                  </motion.div>}
              </Fragment>)}
          </div>
        </div>
      </div>
    </section>;
}